export const ArrowInCarousel = (props) => (<svg width="34" height="33" viewBox="0 0 34 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="Group 5" opacity="0.5">
            <circle id="Ellipse 5" cx="16.8406" cy="16.2273" r="16.2273" fill="black"/>
            <path id="Icon" d="M15.5923 9.98585L20.1775 15.4643C20.7212 16.114 20.7212 17.1674 20.1775 17.8171L15.5923 23.2956" stroke="white" strokeWidth="0.7" strokeLinecap="round"/>
        </g>
    </svg>);
